
import {loadScript} from '@/utils';

const env = process.env.REACT_APP_ENVIRONMENT;

// dongting.js资源地址
export const dongtingSDKUrlMap: any = {
    local: 'https://dongting.cdn.bcebos.com/dongting-front/dev/dongting_launch.min.js',
    rd: 'https://dongting.cdn.bcebos.com/dongting-front/dev/dongting_launch.min.js',
    qa: 'https://dongting.cdn.bcebos.com/dongting-front/dev/dongting_launch.min.js',
    gray: 'https://dongting.cdn.bcebos.com/dongting-front/prod/dongting_launch.min.js',
    online: 'https://dongting.cdn.bcebos.com/dongting-front/prod/dongting_launch.min.js',
};

// dongting APPID
export const dongtingAPPID: any = {
    local: 'aac8dc6c2368d6a5eca7c1d02391d038',
    rd: 'fa9725d49616c199fc875baf6b629d01',
    qa: '383d865fc8f464c90c37598d84cda998',
    gray: '670238361837d45dc7c60de972940078',
    online: '78fafe88d5e3b987074fe0d0c1088ca9',
};

export async function initDongTingSDK() {
    try {
        await loadScript(env ? dongtingSDKUrlMap[env] : dongtingSDKUrlMap.online);
        const appid = env ? dongtingAPPID[env] : dongtingAPPID.online;
    
        setTimeout(() => {
            const DongTing = new (window as any).DongTing('#dongtingWrapper', {
                // 如果初始化-主子页面需要展示不同调研 <推荐>
                page: location.href,
                // 洞听服务号推送的APP_ID
                token: appid,
            });
        }, 300);
    }
    catch (error: any) {
        console.error(new Error(`洞听资源初始化异常：${error.message}`))
    }
}
